export default "__VITE_ASSET__82917f79__"